<style lang="scss">
#multi-select {
  .ex-select {
    span {
      max-height: 20px;
      display: block;
      overflow: hidden;
    }
  }
  ul {
    &.menu {
      position: absolute;
      z-index: 98;
      width: 100%;
      margin-top: 50px;
      padding: 10px;
      border-radius: 8px;
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
    }
    li {
      list-style-type: none;
      &:hover {
        background: #ced4da;
      }
      .v-input__control {
        width: 100%;
        .v-input__slot {
          margin-bottom: 0px;
        }
        i {
          padding-top: 10px;
          padding-bottom: 10px;
        }
        label {
          padding-top: 10px;
          padding-bottom: 10px;
          width: 100%;
        }
      }
    }
    .v-messages {
      display: none;
    }
    .v-input {
      margin-top: 0px;
    }
    hr {
      margin: 0;
    }
  }
}
</style>
<template>
  <v-layout id="multi-select" class="multi-select relative select d-flex" wrap>
    <div class="form-control ex-select" :class="{ invalid: error }" @click="toggleMenu = !toggleMenu">
      <span>{{ multiLabel }}</span>
    </div>
    <ul class="menu pb-0" v-if="toggleMenu">
      <li>
        <v-checkbox
          color="indigo darken-3"
          v-model="isSelectAll"
          :label="$t('SELECT_ALL')"
          @change="selectAll($event)"
        />
      </li>
      <v-divider />
      <li v-for="(option, i) in options" :key="option.id">
        <v-checkbox
          color="indigo darken-3"
          :label="option.text"
          :value="option.value"
          v-model="selected"
        />
        <v-divider v-if="i != options.length - 1" />
      </li>
    </ul>
  </v-layout>
</template>

<script>
export default {
  props: {
    options: Array,
    model: Array,
    error: Boolean,
  },
  data() {
    return {
      label: null,
      toggleMenu: false,
      selected: [],
      isSelectAll: null
    };
  },
  created() {
    if (this.model) this.selected = [...this.model];
    let vm = this;
    window.addEventListener("click", function(event) {
      if (
        vm.toggleMenu &&
        !vm.hasSomeParentTheClass(event.target, "multi-select")
      ) {
        vm.toggleMenu = false;
      }
    });
  },
  watch: {
    selected(value) {
      this.$emit("update:error", false);
      this.$emit("update:model", value);
      if (value.length == this.options.length) {
        this.isSelectAll = true;
      } else {
        this.isSelectAll = false;
      }
    }
  },
  computed: {
    multiLabel() {
      let value = "";
      let insertSymbol = "; ";
      let tempList = this.options.map(x => {
        let value = x.value;
        let content = x.text;
        if (this.selected.find(x => x == value)) {
          return content;
        }
      });
      tempList
        .filter(x => x)
        .forEach(x => {
          value = value.concat("; ", x);
        });
      return value.slice(insertSymbol.length, value.length);
    }
  },
  methods: {
    selectAll(e) {
      this.selected = [];
      if (!e) return false;
      this.selected = this.options.map(x => x.value);
    },
    hasSomeParentTheClass(element, classname) {
      if (
        element.className &&
        element.className.split(" ").indexOf(classname) >= 0
      )
        return true;
      return (
        element.parentNode &&
        this.hasSomeParentTheClass(element.parentNode, classname)
      );
    }
  }
};
</script>
